import { render, staticRenderFns } from "./EntriesTable.vue?vue&type=template&id=1cb023e6&"
import script from "./EntriesTable.vue?vue&type=script&lang=js&"
export * from "./EntriesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports